import { Controller } from "@hotwired/stimulus"

const HOVER_DELAY_MS = 250
const HIGHLIGHT_CLASSES = [
  "relative",
  "after:absolute",
  "after:bottom-0",
  "after:left-0",
  "after:right-0",
  "after:h-[12px]",
  "after:bg-yellow-200/70",
  "dark:after:bg-yellow-500/40",
  "after:-z-10",
  "z-20",
  "highlight-transition"
]

export default class extends Controller {
  connect() {
    this.pendingGroupId = null
    this.highlightedGroupId = null
    this.hoverTimeout = null
  }

  disconnect() {
    this.clearPendingHighlight()
    this.clearHighlight()
  }

  pointerOver(event) {
    const item = this.eventItem(event)
    if (!item || !this.element.contains(item)) return
    if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return

    const groupId = item.dataset.canvasHighlightGroup
    if (!groupId || groupId === this.highlightedGroupId) return

    this.clearPendingHighlight()
    this.pendingGroupId = groupId
    this.hoverTimeout = window.setTimeout(() => {
      this.hoverTimeout = null
      if (this.pendingGroupId !== groupId) return

      this.clearHighlight()
      this.groupElements(groupId).forEach((element) => element.classList.add(...HIGHLIGHT_CLASSES))
      this.highlightedGroupId = groupId
    }, HOVER_DELAY_MS)
  }

  pointerOut(event) {
    const item = this.eventItem(event)
    if (!item || !this.element.contains(item)) return
    if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return

    const groupId = item.dataset.canvasHighlightGroup
    if (groupId !== this.pendingGroupId && groupId !== this.highlightedGroupId) return

    this.clearPendingHighlight()
    this.clearHighlight()
  }

  clearPendingHighlight() {
    if (this.hoverTimeout) window.clearTimeout(this.hoverTimeout)
    this.hoverTimeout = null
    this.pendingGroupId = null
  }

  clearHighlight() {
    if (!this.highlightedGroupId) return

    this.groupElements(this.highlightedGroupId).forEach((element) => element.classList.remove(...HIGHLIGHT_CLASSES))
    this.highlightedGroupId = null
  }

  groupElements(groupId) {
    return this.element.querySelectorAll(`[data-canvas-highlight-group="${CSS.escape(groupId)}"]`)
  }

  eventItem(event) {
    const target = event.target instanceof Element ? event.target : event.currentTarget
    return target?.closest?.("[data-canvas-highlight-group]")
  }
}
